import { app } from '../../../bootstrap/core';
import { actionTabsComponent } from './actionTabs.component';
import './templates/actionTabs.horizontal.tpl.html';
import './templates/actionTabs.toggle.tpl.html';
import './templates/actionTabs.vertical-dropdown.tpl.html';

app.component('actionTabs', actionTabsComponent);
